var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91466 7.5498C9.87609 6.85973 10.4986 5.79345 10.6268 4.61702C10.7551 3.44074 10.377 2.2653 9.58686 1.38429C8.79681 0.503384 7.66931 0 6.48585 0C5.30239 0 4.17492 0.503384 3.38484 1.38429C2.59464 2.26534 2.21657 3.44074 2.34489 4.61702C2.47306 5.79345 3.09561 6.85973 4.05704 7.5498C2.91236 8.03015 1.93478 8.83766 1.24687 9.87105C0.558953 10.9044 0.191028 12.1178 0.189453 13.3591V14H12.7825V13.3591C12.7809 12.1178 12.413 10.9044 11.725 9.87105C11.0371 8.83766 10.0596 8.03015 8.91488 7.5498H8.91466ZM3.61789 4.1949C3.61789 3.43001 3.92172 2.69661 4.46257 2.15573C5.00331 1.61485 5.73685 1.31105 6.50174 1.31105C7.26663 1.31105 8.00017 1.61488 8.54091 2.15573C9.08179 2.69661 9.38559 3.43001 9.38559 4.1949C9.38559 4.95979 9.08176 5.69333 8.54091 6.23407C8.00017 6.77495 7.26663 7.07875 6.50174 7.07875C5.73685 7.07875 5.00331 6.77492 4.46257 6.23407C3.92169 5.69333 3.61789 4.95979 3.61789 4.1949ZM1.51266 12.7183C1.73738 11.1068 2.72999 9.70454 4.17521 8.95701C5.62029 8.20944 7.3383 8.20944 8.78352 8.95701C10.2286 9.70458 11.2212 11.1069 11.4459 12.7183H1.51266Z",
    fill: "#42328A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4a4ef8133dadd397fcfdf840bf001cac.svg";
export { ForwardRef as ReactComponent };